module.exports = __webpack_public_path__ + "static/media/dodgem(16).069889e0.PNG";